import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import Ico from './iconBox';

// import HomeBlog from '../assets/images/blog_1.jpg';
// import person1 from '../assets/images/person_1.jpg';
// import person2 from '../assets/images/person_2.jpg';
// import person3 from '../assets/images/person_3.jpg';
// import person4 from '../assets/images/person_4.jpg';

class Home extends Component {
    state = {

    }
    componentDidMount(){
        window.scrollTo(0, 0)

    }
    render() {
        return (
            <div>
            
 


<br/>



<div className="container">
    <div className="row">
        <div className="col-12">
  
  









<h1>Trust & Safety at YOVHO</h1>
  <p><strong>Your Peace of Mind is Our Top Priority</strong></p>
  <p>At YOVHO, guest safety and satisfaction aren't just goals—they're the foundation of everything we do. Whether you're a local explorer or an international traveler, we go the extra mile to ensure that your experience is secure, seamless, and worry-free. Here’s how:</p>

  <h2>Safety of Guests & Foreign Travelers</h2>
  <p>Your safety is our number one priority. From solo travelers to families and corporate guests, we take every measure to create a secure environment across all YOVHO-verified properties. We pay special attention to the comfort and protection of foreign visitors, making sure they feel at home wherever they stay.</p>

  <h2>Verified & Legally Registered Properties Only</h2>
  <p>Unlike many other platforms, YOVHO works only with properties that are:</p>
  <ul>
    <li>Fully verified by local government and tourism departments</li>
    <li>Legally registered and approved for hospitality use</li>
    <li>Bound by court-registered agreements to meet our strict operational and safety standards</li>
  </ul>
  <p>We work with hotels, hostels, guest houses, apartments, and airport taxi providers, but only after each one passes our rigorous screening process.</p>

  <h2>Surprise Property Inspections</h2>
  <p>To maintain high standards, our trained field teams conduct unannounced weekly inspections using advanced safety and hygiene audit tools. We evaluate:</p>
  <ul>
    <li>Cleanliness and hygiene protocols</li>
    <li>Staff behavior and professionalism</li>
    <li>Emergency response readiness</li>
    <li>General safety of the neighborhood and surrounding environment</li>
  </ul>

  <h2>Guest Privacy & Booking Security</h2>
  <p>We take your privacy seriously. All bookings made through YOVHO are handled with secure technology and strict confidentiality. Your personal information and travel details are protected at every step—from search to check-out.</p>

  <h2>24/7 Emergency Support</h2>
  <p>For extra peace of mind, every YOVHO guest receives access to a dedicated emergency helpline, available 24/7. Whether you need urgent help or just quick advice, our support team is only one call away.</p>

  <h2>Clean, Hygienic & Non-Weird Locations</h2>
  <p>We hand-pick locations that are safe, accessible, and welcoming. We avoid sketchy areas or odd accommodations. Every listing must meet YOVHO’s standards for:</p>
  <ul>
    <li>Sanitation</li>
    <li>Professional staff behavior</li>
    <li>Comfortable, respectful environments for all travelers</li>
  </ul>

  <h2>What Makes YOVHO Different?</h2>
  <ul>
    <li>✔ Only government-verified & legally approved properties</li>
    <li>✔ Transparent operations with formal legal agreements</li>
    <li>✔ Weekly quality checks—without notice</li>
    <li>✔ Clean, safe, traveler-friendly accommodations</li>
    <li>✔ Private and secure booking system</li>
    <li>✔ 24/7 emergency support line</li>
  </ul>

  <p>At YOVHO, we don’t just help you travel—we help you travel confidently. Whether you’re checking in for business, leisure, or an adventure, rest easy knowing you’re backed by a team that truly cares about your trust and safety.</p>

  <h2>Our Team & On-Site Support</h2>
  <p>At YOVHO, you're never alone on your journey. Our dedicated team and local captains are always available to assist you—whether over a call or right on site. Whether it's check-in support, a last-minute request, or unexpected help, our trained representatives are ready to step in and ensure your experience is smooth, safe, and comfortable.</p>

  <p>Your journey is our responsibility—and we take that seriously.</p>







  




        </div>
    </div>
</div>

















        
          </div>
        )
    }
}

export default Home;